export enum EMessageAppIntegration {
  SLACK_WEB_HOOK = 'SlackWebHook',
  SLACK_APP = 'SlackApp',
  TEAMS_WEB_HOOK = 'TeamsWebHook',
  TEAMS_APP = 'TeamsApp',
  GMAIL_APP = 'GmailApp',
  OFFICE365_APP = 'Office365App',
  SENDGRID_APP = 'SendgridApp',
  BREVO_APP = 'BrevoApp',
  GOOGLE_DRIVE = 'GoogleDrive',
  SHAREPOINT = 'Sharepoint',
  S3 = 'S3',
  WEBHOOK = 'WEBHOOK',
}

export enum IntegrationOption {
  SLACK = 'SLACK',
  TEAMS = 'TEAMS',
  GMAIL = 'GMAIL',
  OFFICE365 = 'OFFICE365',
  SENDGRID = 'SENDGRID',
  BREVO = 'BREVO',
  SHAREPOINT = 'SHAREPOINT',
  GOOGLE_DRIVE = 'GOOGLE_DRIVE',
  S3 = 'S3',
  WEBHOOK = 'WEBHOOK',
  EMAIL = 'EMAIL',
}
